import Home from './HomeScreen';

export default Home;
